import React from 'react'

import { useHistory } from 'react-router-dom'

import { useIdleTimer } from 'react-idle-timer'

import { Modal, Button } from '_zari/core'

const InactivityModal = ({ show, handleClose }) => {
  const history = useHistory()

  const handleOnIdle = () => {
    history.push('/logout')
  }

  useIdleTimer({
    timeout: 1000 * 60 * 3,
    onIdle: handleOnIdle,
    debounce: 500
  })

  const clickCerrarSesion = () => {
    history.push('/logout')
  }

  return (
    <Modal show={show} size='sm'>
      <Modal.Body>Se desconectará de la aplicación por inactividad.</Modal.Body>
      <Modal.Footer>
        <Button color='secondary' onClick={clickCerrarSesion}>
          Cerrar Sesión
        </Button>
        <Button onClick={handleClose}>Continuar trabajando</Button>
      </Modal.Footer>
    </Modal>
  )
}

export default React.memo(InactivityModal)
